/**
 * 帳票明細（見積・納品・注文書・請求・外注・仕入）の共通バリデーション。
 * すべての帳票フォームで同一仕様にするため、判定ロジックをここに集約する。
 */

/** 明細行のうちバリデーションに必要な最小フィールド。 */
export interface ValidatableLineItem {
  name: string;
  quantity: number;
  unit: string;
  unitPrice: number;
}

/**
 * 数量・単位・単価のいずれかが入力された行のみ、品目名・数量(1以上)・単位の必須を検証する。
 * 品名（摘要）のみのフリー記載行は許可する（数量・単位・単価がすべて未入力なら検証しない）。
 * @returns 不正な行の0始まりindex。問題が無ければ -1。
 */
export function findIncompleteLineItemIndex(items: ValidatableLineItem[]): number {
  return items.findIndex((it) => {
    const hasQtyUnitPrice =
      it.quantity > 0 || it.unit.trim() !== '' || it.unitPrice !== 0;
    if (!hasQtyUnitPrice) return false;
    return it.name.trim() === '' || it.quantity <= 0 || it.unit.trim() === '';
  });
}

/** 不正な明細行を通知するユーザー向けメッセージ（行番号は 0 始まり index を渡す）。 */
export function incompleteLineItemMessage(rowIndex: number): string {
  return `${rowIndex + 1}行目の明細は品目名・数量（1以上）・単位をすべて入力してください`;
}
